import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Layout/Header/Header";
import Footer from "../../components/Layout/Footer/Footer";
import OffWrap from "../../components/Layout/Header/OffWrap";
import SearchModal from "../../components/Layout/Header/SearchModal";
import Newsletter from "../../components/Common/Newsletter";
import ScrollToTop from "../../components/Common/ScrollTop";
import SiteBreadcrumb from "../../components/Common/Breadcumb";

// Images
import favIcon from "../../assets/img/fav.png";
import Logo from "../../assets/img/logo/dark-logo.png";
import footerLogo from "../../assets/img/logo/lite-logo.png";
import bannerbg from "../../assets/img/breadcrumbs/2.jpg";

// Real Project Data
const projects = [
  {
    id: 1,
    title: "Valar Pay",
    category: "FinTech Solution",
    url: "https://valarpay.com/",
    description: "Secure and seamless digital payment infrastructure for modern businesses.",
    fallbackColor: "#0f172a"
  },
  {
    id: 2,
    title: "Sagama Homes",
    category: "Real Estate",
    url: "http://sagamahomes.com/",
    description: "Premium real estate platform connecting buyers with their dream properties.",
    fallbackColor: "#1d4ed8"
  },
  {
    id: 3,
    title: "Brave Rock",
    category: "Construction & Engineering",
    url: "https://braverockltd.com/",
    description: "Corporate portfolio for a leading construction and engineering firm.",
    fallbackColor: "#ea580c"
  },
  {
    id: 4,
    title: "Natty Pay",
    category: "Digital Finance",
    url: "https://nattypay.com/",
    description: "Next-gen mobile payment solution for fast and secure transactions.",
    fallbackColor: "#7c3aed"
  },
  {
    id: 5,
    title: "Rebate Board",
    category: "E-Commerce",
    url: "http://rebateboard.com/",
    description: "Deal discovery platform offering the best rebates and discounts.",
    fallbackColor: "#059669"
  },
  {
    id: 6,
    title: "Padi Jobs",
    category: "Recruitment",
    url: "http://padijobs.com/",
    description: "Connecting talented professionals with top employers across industries.",
    fallbackColor: "#db2777"
  },
  {
    id: 7,
    title: "Tegal App",
    category: "Mobile Application",
    url: "https://tegalapp.com/",
    description: "Innovative mobile utility application designed for user productivity.",
    fallbackColor: "#2563eb"
  },
  {
    id: 8,
    title: "Bayascript",
    category: "Open Source",
    url: "https://bayascript.com",
    description: "The first Hausa computer programming language built with JS and C++.",
    fallbackColor: "#000000"
  }
];

const BrowserMockup = ({ project, index }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    window.open(project.url, "_blank");
  };

  // Generate dynamic screenshot URL
  const screenshotUrl = `https://api.microlink.io/?url=${encodeURIComponent(project.url)}&screenshot=true&meta=false&embed=screenshot.url`;

  return (
    <div
      className="col-lg-6 col-md-12 mb-50"
      style={{
        opacity: 0,
        animation: `fadeInUp 0.8s ease forwards ${index * 0.1}s`
      }}
    >
      <div
        onClick={handleClick}
        className="browser-mockup"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          background: '#fff',
          borderRadius: '12px',
          boxShadow: isHovered
            ? '0 30px 60px -12px rgba(0, 0, 0, 0.15)'
            : '0 10px 30px -5px rgba(0, 0, 0, 0.05)',
          transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
          transform: isHovered ? 'translateY(-10px)' : 'translateY(0)',
          overflow: 'hidden',
          border: '1px solid #e5e7eb',
          position: 'relative',
          height: '450px',
          display: 'flex',
          flexDirection: 'column',
          cursor: 'pointer'
        }}
      >
        {/* Browser Header */}
        <div style={{
          padding: '12px 16px',
          background: '#ffffff',
          borderBottom: '1px solid #f3f4f6',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          zIndex: 2,
          position: 'relative'
        }}>
          {/* Traffic Lights */}
          <div style={{ display: 'flex', gap: '6px' }}>
            <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#ef4444', opacity: 0.6 }}></div>
            <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#f59e0b', opacity: 0.6 }}></div>
            <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#22c55e', opacity: 0.6 }}></div>
          </div>

          {/* Address Bar */}
          <div style={{
            flex: 1,
            background: '#f9fafb',
            borderRadius: '6px',
            padding: '6px 12px',
            fontSize: '12px',
            color: '#6b7280',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontFamily: 'monospace'
          }}>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.5 }}>
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            <span style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              opacity: 0.7
            }}>
              {project.url.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '')}
            </span>
          </div>
        </div>

        {/* Viewport Content with Real Screenshot */}
        <div style={{
          flex: 1,
          position: 'relative',
          background: '#f8fafc',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Real Website Screenshot */}
          <div style={{
            width: '100%',
            height: '100%',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <img
              src={screenshotUrl}
              alt={`${project.title} Preview`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'top center',
                transition: 'transform 2s ease',
                transform: isHovered ? 'scale(1.1) translateY(0%)' : 'scale(1) translateY(0%)'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.style.background = `linear-gradient(135deg, ${project.fallbackColor} 0%, #ffffff 100%)`;
              }}
            />
            {/* Fallback overlay */}
            <div style={{
              position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
              background: `linear-gradient(135deg, ${project.fallbackColor} 0%, #ffffff 100%)`,
              zIndex: -1
            }}></div>
          </div>

          {/* Info Overlay (Slides Up) */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            padding: '30px',
            background: 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(5px)',
            borderTop: '1px solid #f3f4f6',
            transform: isHovered ? 'translateY(0)' : 'translateY(100%)',
            opacity: isHovered ? 1 : 0,
            transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            zIndex: 10
          }}>
            <div>
              <div style={{
                color: '#ffc107',
                fontSize: '11px',
                fontWeight: 700,
                textTransform: 'uppercase',
                marginBottom: '4px',
                letterSpacing: '0.05em'
              }}>
                {project.category}
              </div>
              <h3 style={{ color: '#111827', fontSize: '20px', margin: 0, fontWeight: 700 }}>{project.title}</h3>
            </div>

            <div
              style={{
                width: '44px',
                height: '44px',
                borderRadius: '50%',
                background: '#111827',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'transform 0.2s ease',
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.2)'
              }}
              className="visit-icon-btn"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
              </svg>
            </div>
          </div>

          {/* Static Title (Visible when not hovered) */}
          <div style={{
            position: 'absolute',
            bottom: '30px',
            left: '0',
            right: '0',
            textAlign: 'center',
            opacity: isHovered ? 0 : 1,
            transition: 'opacity 0.2s ease',
            transform: 'translateY(0)',
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#1f2937',
              margin: 0,
              background: 'rgba(255,255,255,0.9)',
              padding: '8px 20px',
              borderRadius: '100px',
              display: 'inline-block',
              boxShadow: '0 4px 10px rgba(0,0,0,0.05)'
            }}>{project.title}</h3>
          </div>

        </div>
      </div>
    </div>
  );
};

const Portfolio = () => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href={favIcon} />
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="pages"
        secondParentMenu="portfolio"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar="enable"
        TopBarClass="topbar-area home8-topbar"
        emailAddress="hello@syroltech.com"
        Location="Abuja, Nigeria"
      />
      {/* breadcrumb-area-start */}
      <SiteBreadcrumb
        pageTitle="Our Portfolio"
        pageName="Portfolio"
        breadcrumbsImg={bannerbg}
      />
      {/* breadcrumb-area-End */}

      <div className="rs-portfolio pt-100 pb-100 md-pt-80 md-pb-80">
        <div className="container">
          <div className="text-center mb-50">
            <h2 className="title mb-10" style={{ fontSize: '36px', fontWeight: 800 }}>Success Stories</h2>
            <p className="desc" style={{ fontSize: '18px', color: '#666', maxWidth: '700px', margin: '0 auto' }}>
              Explore our selected projects and see how we help businesses transform their digital presence.
            </p>
          </div>

          <div className="row">
            {projects.map((project, index) => (
              <BrowserMockup key={project.id} project={project} index={index} />
            ))}
          </div>
        </div>
      </div>

      <Newsletter
        sectionClass="rs-newsletter style1 orange-color mb--90 sm-mb-0 sm-pb-80"
        titleClass="title mb-0 white-color"
      />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />

      <style>{`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(40px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .visit-icon-btn:hover {
            transform: scale(1.1) rotate(45deg);
            background: #ffc107 !important;
            color: #000 !important;
          }
      `}</style>
    </React.Fragment>
  );
};

export default Portfolio;
